export default __webpack_public_path__ + "media/images/clock-aa9b222d5fba418690afe2ebab3e8e13.svg";